import { Lightning } from '@lightningjs/sdk';
import TextLabel from 'components/common/TextLabel';

export interface AbstractContentTemplateSpec
  extends Lightning.Component.TemplateSpec {
  Heading: typeof TextLabel;
  Description: typeof TextLabel;
}

const SECTION_WIDTH = 802;

export default class AbstractContent
  extends Lightning.Component<AbstractContentTemplateSpec>
  implements
    Lightning.Component.ImplementTemplateSpec<AbstractContentTemplateSpec>
{
  private _Heading = this.getByRef('Heading')!;
  private _Description = this.getByRef('Description')!;

  get title() {
    const title = this._Heading.text?.text;
    const description = this._Description.text?.text.replace(/<\/?b>/g, '');
    return [title, description];
  }

  set heading(value: string) {
    this._Heading.patch({ text: { text: value } });
  }

  set description(value: string) {
    this._Description.patch({ text: { text: value } });
  }

  static override _template(): Lightning.Component.Template<AbstractContentTemplateSpec> {
    return {
      flex: { direction: 'column' },
      w: SECTION_WIDTH,
    };
  }
}
